import { Divider, SkeletonItem, Slot, Text } from '@fluentui/react-components';
import { FC, ReactNode } from 'react';

import useStyles from './AssetCartStyle';

export interface IAssetCardProps {
	id: string;
	icon: Slot<'span'>;
	text: ReactNode;
	backgroudColor?: string;
	onCardClick?: (id: string) => void;
}

const Template = ({ id, backgroudColor, icon, onCardClick, text }: Partial<IAssetCardProps>) => {
	const styles = useStyles();
	return (
		<div className={styles.card} onClick={id !== undefined && onCardClick !== undefined ? () => onCardClick(id) : undefined}>
			<div className={styles.cardIcon} style={{ backgroundColor: backgroudColor }}>
				{icon}
			</div>
			<Divider style={{ flex: 0 }} />
			<div className={styles.cardText}>
				<Text size={200} weight="semibold">
					{text}
				</Text>
			</div>
		</div>
	);
};

const AssetCard = ({ text, ...props }: IAssetCardProps & { text: string }) => (
	<Template
		{...props}
		text={
			<Text size={200} weight="semibold">
				{text}
			</Text>
		}
	/>
);

export const AssetCardSkeleton: FC<Partial<IAssetCardProps>> = (props) => (
	<Template
		{...props}
		text={
			<div style={{ width: '100px', height: '1em' }}>
				<SkeletonItem />
			</div>
		}
	/>
);

export default AssetCard;
